import alarmSituationsAtom from '@/pages/Processes/AlarmSituations/alarmSituations.atom'
import { ISystemEvent } from '@/pages/SystemEvents/systemEvents.types'
import { INotification, INotificationWsMessage } from '@/services/Notification/notifications.types.ts'
import { useRecoilValue } from 'recoil'

interface IProps {
  notification: INotificationWsMessage | INotification | ISystemEvent
}

const NotificationTitle = (props: IProps) => {
  const alarmSituations = useRecoilValue(alarmSituationsAtom).items
  if ('id' in props.notification) {
    switch (props.notification.type) {
      case 'LIFT_ERROR':
      case 'MAINTENANCE_OVERDUE_WARNING':
      case 'MAINTENANCE_OVERDUE_FACT':
      case 'TEXT':
        return props.notification.title
    }
  }
  switch (props.notification.type) {
    case 'ALARM_SITUATION_INCIDENT':
      // @ts-ignore
      const relatedAlarmSituation = alarmSituations.find((el) => el.id === props.notification.payload.alarmSituationId)
      return relatedAlarmSituation?.name || 'Сигнальная ситуация'
    case 'SYSTEM_LOG':
      return 'Системный лог'
    case 'CONNECTION_REQUEST':
      return 'Попытка подключения лифта'
    case 'MOVED_TO_MAINTENANCE':
      return 'Переведен в обслуживание'
    case 'MOVED_FROM_MAINTENANCE_TO_NORMAL':
      return 'Переведен из обслуживания в нормальную работу'
    case 'LP_ERROR':
      if (props.notification.payload.flag === 'WARNING') return 'Предупреждение лифта'
      return 'Ошибка лифта'
    case 'LIFT_ERROR':
    case 'MAINTENANCE_OVERDUE_WARNING':
    case 'MAINTENANCE_OVERDUE_FACT':
    case 'TEXT':
      return props.notification.payload.title
    default:
      return 'Системный лог'
  }
}

export default NotificationTitle
